import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Toolbar from '@mui/material/Toolbar';
import Draggable from 'react-draggable';
import Paper from '@mui/material/Paper';
import ChangePasswordForm from './ChangePasswordForm';

function PaperComponent(props) {
    return (
        <Draggable
            handle="#change-password-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
}

const ChangePasswordDialog = ({userId, afterChange}) => {

    return (
        <Dialog
            onClose={() => afterChange(false)}
            scroll={"paper"}
            open={true}
            fullWidth
            PaperComponent={PaperComponent}
            BackdropProps={{
                sx: {
                    backgroundColor: "rgba(0, 0, 0, 0.2)",
                },
            }}
        >
            <Toolbar disableGutters variant='dense' sx={{m: 0, p: 0, display: 'flex'}}>
                <DialogTitle id="change-password-dialog-title" sx={{cursor: 'move', flexGrow: 1}}>Change
                    Password</DialogTitle>
                <IconButton
                    onClick={() => afterChange(false)}
                    sx={{borderRadius: 0}}
                >
                    <CloseIcon/>
                </IconButton>
            </Toolbar>
            <ChangePasswordForm userId={userId} afterChange={afterChange}/>
        </Dialog>
    );
};

export default ChangePasswordDialog;
